import styled from 'styled-components';
import { layout } from 'src/components/base';

export const SitemapWrapper = styled.span`
  display: block;
  margin: 0 ${layout.measurements.spacing050};
`;
